/*
 * File: /src/router/routes/automations.js
 * Created Date: Sunday May 26th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Wednesday, 7th August 2019 11:00:22 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */

const AutomationList = () =>
  import(
    /* webpackChunkName: "Automations" */ 'src/components/Dashboard/Views/Automations/AutomationList.vue'
  );

const AutomationGallery = () =>
  import(
    /* webpackChunkName: "Automations" */ 'src/components/Dashboard/Views/Automations/AutomationGallery.vue'
  );

const AutomationEditor = () =>
  import(
    /* webpackChunkName: "Automations" */ 'src/components/Dashboard/Views/Automations/AutomationEditor.vue'
  );

const AutomationRollupReport = () =>
  import(
    /* webpackChunkName: "Reports" */ 'src/components/Dashboard/Views/Reports/AutomationRollupReport.vue'
  );

const AutomationRollupNodeDetail = () =>
  import(
    /* webpackChunkName: "Reports" */ 'src/components/Dashboard/Views/Reports/AutomationRollupNodeDetail.vue'
  );

export const automationRoutes = [
  {
    path: 'automations/list/:folderId?',
    name: 'All Automations',
    component: AutomationList,
    props: route => ({ initialId: parseInt(route.params.id)}),
  },
  {
    path: 'automations/gallery',
    name: 'Automation Gallery',
    component: AutomationGallery,
  },
  {
    path: 'automations/edit/:id?',
    name: 'Automation Editor',
    component: AutomationEditor,
    props: route => ({ initialId: parseInt(route.params.id)}),
  },
  {
    path: 'automations/report/:id',
    name: 'Automation Rollup Report',
    component: AutomationRollupReport,
    props: route => ({ workflowId: parseInt(route.params.id) }),
  },
  {
    path: 'automations/report/:id/node/:actionId',
    name: 'Automation Rollup Node Detail',
    component: AutomationRollupNodeDetail,
    props: (route) => {
      let filterDates = null;
      if (route.query.filterDates) {
        const decoded = decodeURIComponent(route.query.filterDates);
        filterDates = JSON.parse(decoded);
      }
      return {
        workflowId: parseInt(route.params.id),
        actionId: parseInt(route.params.actionId),
        initialTab: route.query.tab || 'sent',
        filterDates,
      };
    },
  },
];
